import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Table} from 'reactstrap';
import {Col, Form, FormGroup, Input} from 'reactstrap';
import {toast} from 'react-toastify';

import {DESTINATION_INDEX, DESTINATION, HABIT} from "./constants";
import ErrorMsg from '../common/ErrorMsg';


const empty_item = {
    id: null,
    kpi_planning_category: null,
    item: '',
    is_selected: false
}

export default class KPIPlanningSetting extends Component {
    state = {
        showInput: false,
        showAddButton: true,
        kpiPlanningItem: {
            ...empty_item, 
            agency_location: this.props.agencyLocation,
            job_title: this.props.jobTitle
        }
    }

    addEditItem = (item) => {
        let kpiPlanningItem = item ? {...item} : {
            ...empty_item, 
            agency_location: this.props.agencyLocation,
            job_title: this.props.jobTitle
        };

        this.setState({
            showInput: true, showAddButton: false, kpiPlanningItem
        });
    };

    onChange = (event) => {
        const value = event.target.value;
        const kpiPlanningItem = {...this.state.kpiPlanningItem};
        kpiPlanningItem['item'] = value;

        this.setState({kpiPlanningItem});
    };

    onCancel = () => {
        this.setState({
            showInput: false,
            showAddButton: true,
            kpiPlanningItem: {
                ...empty_item,
                agency_location: this.props.agencyLocation,
                job_title: this.props.jobTitle
            }
        });
    };

    saveItem = async (e) => {
        e.preventDefault();
        let KPIPlanningItemList = [];
        const {selectedCategory, type} = this.props;
        if(this.props.type === DESTINATION_INDEX) {
            KPIPlanningItemList = this.props.kpiPlanning.destinationItems.map(item => ({...item}))
        } else {
            KPIPlanningItemList = this.props.kpiPlanning.habitItems.filter(item => ({...item}))
        }
        let kpiPlanningItem = {...this.state.kpiPlanningItem};
        kpiPlanningItem['kpi_planning_category'] = selectedCategory.id;
        try {
            let result = await this.props.addEditItem(kpiPlanningItem, KPIPlanningItemList, type);
            if (result) {
                toast.success("Saved successfully");
                this.setState({
                    showInput: false,
                    showAddButton: true,
                    item: {
                        ...empty_item, 
                        agency_location: this.props.agencyLocation,
                        job_title: this.props.jobTitle
                    }
                });
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />, {autoClose: 5000});
        }
        return false;
    };

    deleteItem = async (itemId) => {
        let KPIPlanningItemList = [];
        const {type} = this.props;
        if(this.props.type === DESTINATION_INDEX) {
            KPIPlanningItemList = this.props.kpiPlanning.destinationItems.map(item => ({...item}))
        } else {
            KPIPlanningItemList = this.props.kpiPlanning.habitItems.filter(item => ({...item}))
        }
        try {
            let result = await this.props.deleteItem(itemId, KPIPlanningItemList, type);
            if (result) {
                toast.success("Deleted successfully");
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error} />, {autoClose: 5000});
        }
    }

    render() {
        let  itemBody = [], KPIPlanningItems = [], planningType = "";
        const {selectedCategory} = this.props;
        const {kpiPlanningItem, showInput, showAddButton} = this.state;

        if(this.props.type === DESTINATION_INDEX) {
            planningType = DESTINATION;
            KPIPlanningItems = this.props.kpiPlanning.destinationItems.filter(item => 
                item.kpi_planning_category === selectedCategory.id
            )
        } else {
            planningType = HABIT;
            KPIPlanningItems = this.props.kpiPlanning.habitItems.filter(item => 
                item.kpi_planning_category === selectedCategory.id
            )
        }

        itemBody = KPIPlanningItems.map((item, index) =>
            <tr key={index}>
                <th className="font-weight-bold">{index + 1}</th>
                <td>{item.item}</td>
                <td className="center-block">
                    <Button color="success" size="sm"
                            onClick={() => this.addEditItem(item)}>
                        Edit
                    </Button>{' '}
                    <Button color="warning" size="sm"
                            onClick={() => this.deleteItem(item.id)}>
                        Delete
                    </Button>
                </td>
            </tr>
        );
        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggle}>
                    {planningType} - {selectedCategory.category}
                </ModalHeader>
                <ModalBody>
                    <div>
                        <Table hover striped size="sm" className="bg-white">
                            <thead>
                            <tr>
                                <th className="font-weight-bold">#</th>
                                <th className="font-weight-bold">Title</th>
                                <th className="text-center font-weight-bold">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                                {itemBody}
                            </tbody>
                        </Table>
                    </div>

                    <div className={showInput ? '' : 'hidden'}>
                        <Form>
                            <fieldset className="card card-body pt-1">
                                <legend className="mb-0 pb-1" style={{width:"fit-content"}}><small><small>{kpiPlanningItem.id ? `Edit ${planningType}` : `Add ${planningType}`} </small></small></legend>
                                <FormGroup row className="mb-1">
                                    <Col sm={8}>
                                        <Input type="text" name="item"
                                                value={kpiPlanningItem.item}
                                                onChange={this.onChange}/>
                                    </Col>
                                
                                    <Col sm={2}>
                                        <Button type="submit" color="success" onClick={this.saveItem}>Save</Button>
                                    </Col>
                                    <Col sm={2}>
                                        <Button type="button" color="warning" onClick={this.onCancel}>Cancel</Button>
                                    </Col>
                                </FormGroup>
                            </fieldset>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="info"
                            onClick={() => this.addEditItem("")}
                            className={showAddButton ? '' : 'hidden add-button'}>
                        Add {planningType}
                    </Button>{' '}
                    <Button color="secondary" onClick={this.props.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/kpiPlanning/SettingModal.js